"use client";

import { parseAsString, useQueryState } from "nuqs";

/**
 * The id of the POI whose details are open, `null` when none is.
 *
 * Note this is the *in-app* selection, which coexists with the standalone
 * `/[locale]/poi/[collectionId]/[featureId]` route: the route is the shareable,
 * crawlable, server-rendered representation, while this param is what the map and
 * sidebar read to highlight and open a POI without a navigation.
 */
export function useSelectedItemId() {
  const [selectedItemId, setSelectedItemId] = useQueryState(
    "selectedItem",
    parseAsString
  );

  return { selectedItemId, setSelectedItemId };
}
